export default [
  {
    path: "/logistica",
    name: "logistica",
    label: "Logística",
    component: () => import("@/components/home/MenuLogistica.vue"),
  },
  {
    path: "/logistica/cadastros",
    name: "logistica.cadastros",
    label: "Cadastros",
    component: () => import("@/components/logistica/cadastros/home-cadastros.vue"),
  },
  {
    path: "/logistica/cadastros/transportadoras/cadastro",
    name: "logistica.cadastros.transportadoras.novo",
    label: "Cadastrar Transportadoras",
    component: () => import("@/components/logistica/cadastros/transportadora/form-transportadora.vue"),
  },
  {
    path: "/logistica/cadastros/transportadoras/editar/:id",
    name: "logistica.cadastros.transportadoras.editar",
    label: "Editar Transportadoras",
    component: () => import("@/components/logistica/cadastros/transportadora/form-transportadora.vue"),
  },
  {
    path: "/logistica/cadastros/transportadoras",
    name: "logistica.cadastros.transportadoras",
    label: "Visualizar Transportadoras",
    component: () => import("@/components/logistica/cadastros/transportadora/transportadoras.vue"),
  },
  {
    path: "/logistica/cadastros/fretes/cadastro",
    name: "logistica.cadastros.fretes.novo",
    label: "Cadastrar Fretes",
    component: () => import("@/components/logistica/cadastros/fretes/novo-frete.vue"),
  },
  {
    path: "/logistica/cadastros/fretes/cadastro/:id",
    name: "logistica.cadastros.fretes.editar",
    label: "Editar Fretes",
    component: () => import("@/components/logistica/cadastros/fretes/novo-frete.vue"),
  },
  {
    path: "/logistica/cadastros/fretes",
    name: "logistica.cadastros.fretes",
    label: "Visualizar Fretes",
    component: () => import("@/components/logistica/cadastros/fretes/gerenciar-fretes.vue"),
  },
  {
    path: "/logistica/cadastros/rotas/cadastro",
    name: "logistica.cadastros.rotas.novo",
    label: "Cadastrar Rotas",
    component: () => import("@/components/logistica/cadastros/rotas/nova-rota.vue"),
  },
  {
    path: "/logistica/cadastros/rotas/cadastro/:id",
    name: "logistica.cadastros.rotas.editar",
    label: "Editar Rotas",
    component: () => import("@/components/logistica/cadastros/rotas/nova-rota.vue"),
  },
  {
    path: "/logistica/cadastros/rotas",
    name: "logistica.cadastros.rotas",
    label: "Visualizar Rotas",
    component: () => import("@/components/logistica/cadastros/rotas/gerenciar-rotas.vue"),
  },
  {
    path: "/logistica/cte",
    name: "logistica.cte",
    label: "CT-e",
    component: () => import("@/components/logistica/cte/home-cte.vue"),
  },
  {
    path: "/logistica/cte/novo",
    name: "logistica.cte.novo",
    label: "Criar CT-e",
    component: () => import("@/components/logistica/cte/cte-novo.vue"),
  },
  {
    path: "/logistica/cte/editar/:id",
    name: "logistica.cte.editar",
    label: "Editar CT-e",
    component: () => import("@/components/logistica/cte/cte-novo.vue"),
  },
  {
    path: "/logistica/cte-show/:id",
    name: "logistica.cte.visualizar",
    label: "Visualizar CT-e (Detalhes)",
    component: () => import("@/components/logistica/cte/cte-show.vue"),
  },
  {
    path: "/logistica/gerenciar-cte",
    name: "logistica.cte.gerenciar",
    label: "Visualizar CT-e (Tabela)",
    component: () => import("@/components/logistica/cte/gerenciar-cte.vue"),
  },
  {
    path: "/logistica/mdfe-show/:id",
    name: "logistica.mdfe.visualizar",
    label: "Visualizar MDF-e (Detalhes)",
    component: () => import("@/components/logistica/mdfe/mdfe-show.vue"),
  },
  {
    path: "/logistica/mdfe/editar/:id",
    name: "logistica.mdfe.editar",
    label: "Editar MDF-e",
    component: () => import("@/components/logistica/mdfe/novo-mdfe.vue"),
  },
  {
    path: "/logistica/mdfe",
    name: "logistica.mdfe",
    label: "MDF-e",
    component: () => import("@/components/logistica/mdfe/home-mdfe.vue"),
  },
  {
    path: "/logistica/mdfe/gerenciar",
    name: "logistica.mdfe.gerenciar",
    label: "Visualizar MDF-e (Tabela)",
    component: () => import("@/components/logistica/mdfe/gerenciar-mdfe.vue"),
  },
  {
    path: "/logistica/mdfe/novo",
    name: "logistica.mdfe.novo",
    label: "Criar MDF-e",
    component: () => import("@/components/logistica/mdfe/novo-mdfe.vue"),
  },
  {
    path: "/logistica/romaneio",
    name: "logistica.romaneio",
    label: "Romaneios",
    component: () => import("@/components/logistica/romaneio/home-romaneio.vue"),
  },
  {
    path: "/logistica/expedicao",
    name: "logistica.expedicao",
    label: "Expedição",
    component: () => import("@/components/logistica/wms/gerenciar-saidas.vue"),
  },
  {
    path: "/logistica/expedicao/selecionar-deposito/:id",
    name: "logistica.expedicao.selecionar-deposito",
    label: "Selecionar Depósitos",
    component: () => import("@/components/logistica/wms/selecionar-deposito-saidas.vue"),
  },
  {
    path: "/logistica/romaneio/gerenciar",
    name: "logistica.romaneio.gerenciar",
    label: "Gerenciar Romaneios",
    component: () => import("@/components/logistica/romaneio/gerenciar-romaneio.vue"),
  },
  {
    path: "/logistica/romaneio/gerenciar/emitir",
    name: "logistica.romaneio.novo",
    label: "Criar Romaneios",
    component: () => import("@/components/logistica/romaneio/novo-romaneio.vue"),
  },
  {
    path: "/logistica/romaneio/gerenciar/emitir/:id",
    name: "logistica.romaneio.editar",
    label: "Editar Romaneios",
    component: () => import("@/components/logistica/romaneio/novo-romaneio.vue"),
  },
  {
    path: "/logistica/cadastros/motoristas/cadastro",
    name: "logistica.cadastros.motoristas.novo",
    label: "Cadastrar Motoristas",
    component: () => import("@/components/logistica/cadastros/motorista/form-motorista.vue"),
  },
  {
    path: "/logistica/cadastros/motoristas/editar/:id",
    name: "logistica.cadastros.motoristas.editar",
    label: "Editar Motoristas",
    component: () => import("@/components/logistica/cadastros/motorista/form-motorista.vue"),
  },
  {
    path: "/logistica/cadastros/motoristas",
    name: "logistica.cadastros.motoristas",
    label: "Visualizar Motoristas",
    component: () => import("@/components/logistica/cadastros/motorista/motorista.vue"),
  },
  {
    path: "/logistica/cadastros/veiculos/cadastro",
    name: "logistica.cadastros.veiculos.novo",
    label: "Cadastrar Veículos",
    component: () => import("@/components/logistica/cadastros/veiculo/form-veiculo.vue"),
  },
  {
    path: "/logistica/cadastros/veiculos/editar/:id",
    name: "logistica.cadastros.veiculos.editar",
    label: "Editar Veículos",
    component: () => import("@/components/logistica/cadastros/veiculo/form-veiculo.vue"),
  },
  {
    path: "/logistica/cadastros/veiculos",
    name: "logistica.cadastros.veiculos",
    label: "Visualizar Veículos",
    component: () => import("@/components/logistica/cadastros/veiculo/veiculo.vue"),
  },
  {
    path: "/logistica/cadastros/empresas-gerenciar",
    name: "logistica.cadastros.empresas.gerenciar",
    label: "Visualizar Empresas de Remetente/Destinatário (CT-e)",
    component: () => import("@/components/logistica/cadastros/empresas/gerenciar-empresa.vue"),
  },
  {
    path: "/logistica/dashboard/otif",
    name: "logistica.dashboard.otif",
    label: "Visualizar Dashboard OTIF",
    component: () => import("@/components/logistica/dashboard/dashboard-otif.vue"),
  },
];
